export default {"src":"/statics/ecommerce/_next/static/media/big.5db07218.svg","height":187,"width":391,"blurWidth":0,"blurHeight":0};